import React from "react"
import {Avatar, Box, useMediaQuery} from "@chakra-ui/react"
import APIconButton from "./APIconButton"
import {useIntl} from "react-intl"
import { FullScreenContext } from "../contexts/FullScreenContext"
import {useSettingsContext} from "../contexts/SettingsContext";

const NavMenu = (
  {openProfile, openSettings, profileBtnTabIndex, fullscreenBtnTabIndex, settingsBtnTabIndex} :
  {
    openProfile: () => void,
    openSettings: () => void,
    profileBtnTabIndex?: number,
    fullscreenBtnTabIndex?: number,
    settingsBtnTabIndex?: number
  }
) => {
  const intl = useIntl();
  const { profileData, avatar } = useSettingsContext();
  const [isLargeScreen] = useMediaQuery("(min-width: 764px)");

  return (
    <FullScreenContext.Consumer>
      {({ fullScreen, toggleFullScreen }) => (
        <Box sx={{
          ml: "auto",
          width: ["fit-content", undefined],
          flex: "1",
          display: "flex",
          justifyContent: "center"
        }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              ml: "auto"
            }}
          >
            <APIconButton
              tabIndex={profileBtnTabIndex}
              onClick={() => openProfile()}
              style={{borderRadius: "12px"}}
              aria-label={intl.formatMessage({
                id: 'aria-label-profile-menu', defaultMessage: 'Menu du profil'
              })}
            >
              <Avatar
                src={avatar && avatar !== "0" ? `avatars/${avatar}.svg` : profileData ? undefined : `avatars/fire.svg`}
                name={intl.locale === "fr" ? profileData?.username_fr : profileData?.username}
                width={isLargeScreen ? 34 : 27}
                height={isLargeScreen ? 34 : 27}
              />
            </APIconButton>
            <Box my={0} mx={isLargeScreen ? "20px" : "16px"}>
              <APIconButton
                tabIndex={fullscreenBtnTabIndex}
                onClick={() => toggleFullScreen()}
                style={{borderRadius: isLargeScreen ? "15px" : "12px"}}
                aria-label={intl.formatMessage({
                  id: 'aria-label-fullscreen-button', defaultMessage: 'Bouton plein écran'
                })}
              >
                <img
                  src={
                    fullScreen ? `${process.env.REACT_APP_BASE_URL}/arrow_close.svg` :`${process.env.REACT_APP_BASE_URL}/arrow_open.svg`
                  }
                  alt=""
                  style={{width: isLargeScreen ? "30px" : "24px", height: isLargeScreen ? "30px" : "24px"}}
                />
              </APIconButton>
            </Box>
            <APIconButton
              tabIndex={settingsBtnTabIndex}
              onClick={() => openSettings()}
              style={{borderRadius: "12px"}}
              aria-label={intl.formatMessage({
                id: 'aria-label-options', defaultMessage: 'Options'
              })}
            >
              <img
                src={`${process.env.REACT_APP_BASE_URL}/setting.svg`}
                alt=""
                style={{width: isLargeScreen ? "30px" : "24px", height: isLargeScreen ? "30px" : "24px"}}
              />
            </APIconButton>
          </Box>
        </Box>
      )}
    </FullScreenContext.Consumer>
  )
}

export default NavMenu